// @ts-nocheck
// Cross-domain cart handoff receiver (main domain only, loaded as a module).
//
// When a #pv_cart= payload is present, the ads cart's items are added to the
// main cart and the cart UI is refreshed IN PLACE via the Section Rendering API
// — no page reload, so the pre-merge page never flashes. The transfer overlay
// (pv-cart-transfer-overlay, keyed on the same hash) masks the brief merge and
// is lifted the instant the merged UI is ready.
//
//   • cart-icon hop    → main /cart, line items + count refreshed
//   • browse-limit hop → same page on main, merged silently (drawer stays shut)
//   • add-to-cart hop  → same PDP on main, drawer refreshed and opened
//
// The merge is driven by morphing sections directly (not by dispatching the
// theme's cart:update event) so the drawer's auto-open never fires on the
// silent hops — we open it explicitly, and only on the add-to-cart hop.
(function () {
  var PREFIX = '#pv_cart=';
  var hash = window.location.hash;
  if (hash.indexOf(PREFIX) !== 0) return;

  var docEl = document.documentElement;
  var reveal = function () { docEl.removeAttribute('data-pv-cart-transfer'); };

  var cleanUrl = window.location.pathname + window.location.search;
  // Strip the hash immediately so back-nav and reloads are clean. Parse the
  // payload from the captured `hash` — window.location.hash is empty after this.
  history.replaceState(null, '', cleanUrl);

  var parsed;
  try {
    parsed = JSON.parse(decodeURIComponent(hash.slice(PREFIX.length)));
  } catch (e) {
    reveal();
    return;
  }

  // Payload is { items, drawer }; tolerate a legacy bare array just in case.
  var items;
  var openDrawer = false;
  if (Array.isArray(parsed)) {
    items = parsed;
  } else if (parsed && Array.isArray(parsed.items)) {
    items = parsed.items;
    openDrawer = !!parsed.drawer;
  }
  if (!items || !items.length) {
    reveal();
    return;
  }

  // Sections to refresh in place: every cart-items-component (cart drawer + cart
  // page) plus the section that holds the cart-count bubble (the header).
  var sectionIds = {};
  document.querySelectorAll('cart-items-component[data-section-id]').forEach(function (el) {
    sectionIds[el.dataset.sectionId] = true;
  });
  document.querySelectorAll('cart-icon').forEach(function (icon) {
    var section = icon.closest('.shopify-section');
    if (section && section.id) sectionIds[section.id.replace(/^shopify-section-/, '')] = true;
  });
  var ids = Object.keys(sectionIds);

  // Open the cart drawer once it has upgraded, revealing the page as it opens so
  // there's no PDP-without-drawer frame. Never trap the visitor behind the overlay.
  var openDrawerThenReveal = function () {
    var tries = 0;
    (function poll() {
      var drawer = document.querySelector('cart-drawer-component');
      if (drawer && typeof drawer.open === 'function') {
        reveal();
        drawer.open();
        return;
      }
      if (tries++ < 40) setTimeout(poll, 100); // up to ~4s for the module to upgrade
      else reveal();
    })();
  };

  (async function () {
    try {
      var body = { items: items };
      if (ids.length) body.sections = ids.join(',');

      var addUrl = (window.Theme && Theme.routes && Theme.routes.cart_add_url) || '/cart/add.js';
      var response = await fetch(addUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify(body)
      });
      var data = await response.json();

      // Morph the returned sections in place (cart items, cart page, count).
      if (data && data.sections) {
        var renderer = await import('@theme/section-renderer');
        for (var id in data.sections) {
          if (data.sections[id]) {
            try { await renderer.morphSection(id, data.sections[id]); } catch (e) {}
          }
        }
      }
    } catch (e) {
      // Fall through to reveal — a failed merge must not leave the spinner stuck.
    } finally {
      if (openDrawer) openDrawerThenReveal();
      else reveal();
    }
  })();
})();
